<section class="section">
  <header
    (click)="toggleExpanded()"
    (keydown.enter)="toggleExpanded()"
    (keydown.space)="toggleExpanded()"
    [ngClass]="expanded ? 'expanded' : 'collapsed'"
    tabindex="0"
    [title]="[(expanded ? 'Hide ' : 'Show ') + 'Blank Field Default format for this field']"
    >
    <mat-icon fontIcon="edit_note"></mat-icon>
    <h3>
      Blank field default
      @if (hasChanged) {
        <span class="has-changed-indicator" title="Update field changes below">*</span>
      }
    </h3>
    <mat-icon fontIcon="expand_more" class="expand-icon"></mat-icon>
  </header>
  @if (expanded) {
    <table class="table-full-width" @configSectionsInOut>
      <tr>
        <td><p>Set default value to appear if field is blank</p></td>
      </tr>
      <tr>
        <td>
          <span class="input-container">
            <input [(ngModel)]="defaultEmptyValue" placeholder="Default value if blank" (ngModelChange)="updateParent()" />
          </span>
        </td>
      </tr>
    </table>
  }
</section>
